import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import {ScratchCard, SCRATCH_TYPE} from 'scratchcard-js';
import { InteractionsService } from 'src/app/services/interactions.service';
import { MethodsService } from 'src/app/services/methods.service';

@Component({
  selector: 'app-scratch',
  templateUrl: './scratch.component.html',
  styleUrls: ['./scratch.component.scss']
})
export class ScratchComponent implements OnInit, OnDestroy {
  @Input('interactionId') interactionId;
  public content;
  percent;
  showDetails = false;
  button = false;
  index = 0;
  config =
    {
      a11y: true,
      observer: true,
      direction: 'horizontal',
      threshold: 50,
      spaceBetween: 5,
      slidesPerView: 1,
      centeredSlides: true,
      navigation: true,
      pagination: false,
      scrollbar: false,
      draggable: true
    };
  public interaction;
  private interactionsSubscriber;


  constructor(
    private interactionsService: InteractionsService,
    private methods: MethodsService
  ) { }

  ngOnInit(): void {
    this.interactionsSubscriber = this.interactionsService.interactions$.subscribe(interactions => {
      this.interaction = interactions.filter(interaction => interaction.id === this.interactionId)[0];
      this.methods.get('assets/data/' + this.interaction.content.configId + '.config.json').subscribe( config => {
        this.content = config;
        const scContainer = document.getElementById('js--sc--container');
        console.log('config', config);
        const sc = new ScratchCard('#js--sc--container', {
          enabledPercentUpdate: true,
          scratchType: SCRATCH_TYPE.CIRCLE,
          containerWidth: config.containerWidth,
          containerHeight: config.containerHeight,
          imageForwardSrc: config.imageForwardSrc,
          imageBackgroundSrc: config.imageBackgroundSrc,
          htmlBackground: '',
          clearZoneRadius: config.clearZoneRadius,
          percentToFinish: config.percentToFinish,
          nPoints: config.nPoints,
          pointSize: config.pointsize,
          callback: () => {
            this.interaction.completed = {
              onComplete: true,
              status: 'success'
            };
            this.interactionsService.setCompleted(this.interaction);
            this.interactionsService.updateInteraction(this.interaction);
            sc.finish();
          }
        });
        sc.init();
      });
    });
  }
  ngOnDestroy() {
    this.interactionsSubscriber.unsubscribe();
  }

}
